import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=f662046e&scoped=true&lang=pug&"
var script = {}
import style0 from "./Terms.vue?vue&type=style&index=0&id=f662046e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f662046e",
  null
  
)

export default component.exports